import $ from 'jquery';
import 'jquery-backstretch';
import 'lightslider';
import 'waypoints/lib/jquery.waypoints.min';
import Cookies from './ui/Cookies';

const App = {
  ui: {
    dataBg: $('[data-bg]'),
    sliders: $('.js-slider'),
    animations: $('[data-animation]'),
  },
  init() {
    Cookies.init();
    this.initBackstretch();
    this.initSlider();
    this.initAnimation();
    this.initNav();
    this.initSmoothScroll();
    this.removeOrphans();
  },
  removeOrphans() {
    // eslint-disable-next-line max-len
    $('.js-orphans p, .js-orphans h1, .js-orphans h2, .js-orphans h3, .js-orphans h4').each((key, item) => {
      const $this = $(item);
      let text = $this.text();
      text = text.replace(/(\s)([\S])[\s]+/g, '$1$2&nbsp;');
      text = text.replace(/(\s)([^<][\S]{1})[\s]+/g, '$1$2&nbsp;');
      $this.html(text);
    });
  },
  initSmoothScroll() {
    $(document).on('click', 'a[href^="#"]', function(event) {
      event.preventDefault();

      $('html, body').animate({
        // eslint-disable-next-line no-invalid-this
        scrollTop: $($.attr(this, 'href')).offset().top,
      }, 500);
    });
  },
  /**
   * Init backstretch plugin.
   */
  initBackstretch() {
    this.ui.dataBg.each((key, item) => {
      const $item = $(item);
      const bg = $item.data('bg');
      let mobile = $item.data('bg-mobile');

      if (!mobile) {
        mobile = bg;
      }

      $item.backstretch([
        [
          {width: 1080, url: bg},
          {width: 550, url: mobile},
        ],
      ]);
    });
  },
  initSlider() {
    this.ui.sliders.each((key, item) => {
      const $item = $(item);
      $item.lightSlider({
        auto: false,
        item: 1,
        mode: 'slide',
        speed: 1000,
        pause: 4000,
        adaptiveHeight: false,
        slideMargin: 0,
        loop: true,
        controls: true,
        pager: false,
      });
    });
  },
  initAnimation() {
    this.ui.animations.each((key, item) => {
      const $this = $(item);
      const animationClass = $this.attr('data-animation');
      const animationDelay = $this.attr('data-animation-delay');
      $this.css({
        'animation-delay': animationDelay,
      });
      $this.waypoint(() => {
        $this.addClass('animated').addClass(animationClass);
      }, {
        triggerOnce: true,
        offset: '80%',
      });
    });
  },
  initNav() {
    const $mobile = $('.js-mobile');
    const $openNav = $('.js-open-nav');
    $openNav.on('click', () => {
      $mobile.addClass('is-active');
    });

    $(document).on('click', (event) => {
      const $target = $(event.target);

      if (
        !$target.closest('.js-mobile').length &&
        $mobile.hasClass('is-active') &&
        $target != $openNav &&
        !$target.closest('.js-open-nav').length
      ) {
        $mobile.removeClass('is-active');
      }
    });
  },
};

export default App;
